
import { defineComponent, computed, ref } from 'vue';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { Language } from '@/interfaces/language.interface';
import languageService from '@/services/language.service';
import CxLanguagePicker from '@/app/CxLanguagePicker.vue';

export default defineComponent({
  name: 'CxShell',
  components: {
    CxLanguagePicker,
  },
  setup() {
    // Data
    const availableLanguages = ref(languageService.getAvailableLanguages());
    const isChineseApp = ref(process.env.VUE_APP_CHINA === 'true');
    const licenseChina = ref(process.env.VUE_APP_CHINA_LICENCE);
    const language = useGettext();

    // Computed
    const translations = computed((): {
        privacy: string;
        cookie: string;
        imprint: string;
        settings: string;
        } => {
      return {
        privacy: language.$gettext('Privacy Policy'),
        cookie: language.$gettext('Cookie Policy'),
        imprint: language.$gettext('Imprint'),
        settings: language.$gettext('Cookie Settings')
      };
    });
    const hasCookieMenu = computed((): boolean => process.env.VUE_APP_SHOW_COOKIE_CONSENT === 'true');
    const privacyPolicyUrl = computed((): string => isChineseApp.value ? 'http://conx-cn-privacy-policy-page.s3-website.cn-north-1.amazonaws.com.cn' : 'https://leica-geosystems.com/global/privacy-policy');

    // Methods
    const changeLanguage = (selectedLanguage: Language): void => {
      languageService.changeLanguage(selectedLanguage.locale);
    };

    const openCookiePolicy = (): void => { window.open('/ui2/documents/cookie-policy.html', '_blank'); };

    // Expose properties and methods
    return {
      // Data
      availableLanguages,
      isChineseApp,
      licenseChina,
      // Computed
      hasCookieMenu,
      translations,
      privacyPolicyUrl,
      // Methods
      changeLanguage,
      openCookiePolicy
    };
  },
});
